import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from '@/store'
import VueSwal from 'vue-swal'
import './styles-connect.sass'
import Vue2Editor from 'vue2-editor'
import vueDebounce from 'vue-debounce'

Vue.config.productionTip = process.env.NODE_ENV !== 'production'
Vue.use(vueDebounce)
Vue.use(VueSwal)
Vue.use(Vue2Editor)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
